export const eventsData = [
    {
      title: "Lorem ipsus",
      endDate: "20.08.2022",
      photoURL:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Stray_kitten_Rambo002.jpg/1200px-Stray_kitten_Rambo002.jpg",
      id: 1,
    },
    {
      title: "Lorem ipsus",
      endDate: "20.08.2022",
      photoURL:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Stray_kitten_Rambo002.jpg/1200px-Stray_kitten_Rambo002.jpg",
      id: 2,
    },
    {
      title: "Lorem ipsus",
      endDate: "20.08.2022",
      photoURL:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Stray_kitten_Rambo002.jpg/1200px-Stray_kitten_Rambo002.jpg",
      id: 3,
    },
    {
      title: "Lorem ipsus",
      endDate: "20.08.2022",
      photoURL:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Stray_kitten_Rambo002.jpg/1200px-Stray_kitten_Rambo002.jpg",
      id: 4,
    },
    {
      title: "Lorem ipsus",
      endDate: "20.08.2022",
      photoURL:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Stray_kitten_Rambo002.jpg/1200px-Stray_kitten_Rambo002.jpg",
      id: 5,
    },
    {
      title: "Lorem ipsus",
      endDate: "20.08.2022",
      photoURL:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Stray_kitten_Rambo002.jpg/1200px-Stray_kitten_Rambo002.jpg",
      id: 6,
    },
    {
      title: "Lorem ipsus",
      endDate: "20.08.2022",
      photoURL:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Stray_kitten_Rambo002.jpg/1200px-Stray_kitten_Rambo002.jpg",
      id: 7,
    },
    {
      title: "Lorem ipsus",
      endDate: "20.08.2022",
      photoURL:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Stray_kitten_Rambo002.jpg/1200px-Stray_kitten_Rambo002.jpg",
      id: 8,
    },
  ];